module.exports = __webpack_public_path__ + "296dedc50caa9a665ecbe6b54ef0c8e3.svg";